// MO4.1
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TierProductCardDumb from '../TierProductCardDumb/';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import BuyCoreButton from '../../Button/BuyCoreButton';
import SubscribeButton from '../../Button/SubscribeButton';
import { getTierDescription, getTranslatedTierInfo } from '../_helpers';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import TierStateBadges from '../../Tier/TierStateBadges';
import MoreActionsButton from '../../Tier/MoreActionsButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import TierConsumerReduxModule from '../../Tier/redux/consumer/ModuleLoadable';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import HiddenOverlay from '../HiddenOverlay';
import s from './TierProductCard.scss';
const TierProductCard = (_param)=>{
    var { deviation , onPublish , onSubmitToTier  } = _param, rest = _object_without_properties(_param, [
        "deviation",
        "onPublish",
        "onSubmitToTier"
    ]);
    var _deviation_tier, _deviation_tier1, _deviation_tier_discord;
    const { t  } = useTranslation();
    const [isPublishing, setIsPublishing] = useState(false);
    const [matureFilterOverridden, setMatureFilterOverridden] = useState(false);
    const { isOwner  } = useSubscriptionTier(deviation);
    const info = isOwner ? undefined : getTranslatedTierInfo(deviation, t);
    const canPublish = (_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.canUserPublish;
    const hasDiscord = (_deviation_tier1 = deviation.tier) === null || _deviation_tier1 === void 0 ? void 0 : (_deviation_tier_discord = _deviation_tier1.discord) === null || _deviation_tier_discord === void 0 ? void 0 : _deviation_tier_discord.connected;
    const { showBlocked , overrideMatureFilter  } = useDeviationMatureFilter(deviation);
    const onOverrideFilterClick = useCallback(()=>{
        overrideMatureFilter();
        setMatureFilterOverridden(true);
    }, [
        overrideMatureFilter,
        setMatureFilterOverridden
    ]);
    let ctaButton;
    if (!deviation.tier) {
        return null;
    }
    const onPublishClick = ()=>{
        if (onPublish) {
            setIsPublishing(true);
            onPublish(deviation);
            // this is a poor man's solution to unlock the button, in case we can't one-click publish (e.g. not all required fields are filled)
            // and open the edit tier popup. if the users closes it, we want to button to render restored in active state.
            setTimeout(()=>{
                setIsPublishing(false);
            }, 3000);
        }
    };
    if (isOwner) {
        if (deviation.tier.state === 'draft') {
            if (canPublish) {
                // publishDraftTierSaga
                ctaButton = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SolidButton, {
                    variant: "approval-green",
                    size: "large",
                    onClick: onPublishClick,
                    loading: isPublishing
                }, t('deviationview.tierCard.cta.publish')), /*#__PURE__*/ React.createElement(TierConsumerReduxModule, null));
            } else {
                // missing core - currently the only reason the owner cant publish
                ctaButton = /*#__PURE__*/ React.createElement(BuyCoreButton, {
                    size: "large",
                    biData: {
                        referral_info: ReferralType.SUBSCRIPTIONS_TIER_DRAFT
                    }
                }, t('deviationview.tierCard.cta.getCore'));
            }
        } else if (deviation.tier.state === 'active') {
            ctaButton = /*#__PURE__*/ React.createElement(GhostButton, {
                variant: "main",
                size: "large",
                onClick: onSubmitToTier,
                biData: BiData({
                    evid: 704,
                    sectionname: 'tiers'
                })
            }, t('deviationview.tierCard.cta.submitToTier'));
        }
    } else {
        ctaButton = /*#__PURE__*/ React.createElement(SubscribeButton, {
            size: "large",
            tier: deviation,
            matureFilterDisabled: true
        });
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['card-root']
    }, showBlocked && /*#__PURE__*/ React.createElement(HiddenOverlay, {
        className: s['card-overlay'],
        showBackground: false,
        deviation: deviation,
        overrideMatureFilter: onOverrideFilterClick
    }), /*#__PURE__*/ React.createElement(TierProductCardDumb, _extends({
        info: info,
        coverImage: deviation.coverImage,
        showMatureCover: showBlocked || matureFilterOverridden,
        coverAreaExtrasLeft: /*#__PURE__*/ React.createElement(TierStateBadges, {
            deviation: deviation,
            showNeedCoreState: true,
            showPendingDeletionState: true
        }),
        dataHook: deviation.url,
        coverAreaExtrasRight: /*#__PURE__*/ React.createElement(MoreActionsButton, {
            deviation: deviation
        }),
        stats: deviation.tier.stats,
        title: deviation.title,
        tierState: deviation.tier.state,
        description: getTierDescription(deviation),
        price: deviation.tier.dollarPrice,
        benefits: deviation.tier.benefits,
        ctaButton: ctaButton,
        hasDiscord: hasDiscord
    }, rest)));
};
TierProductCard.displayName = 'TierProductCard';
export default TierProductCard;
